import { BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import ToastWrapper from "./component/toast/toast-wrapper";
import PublicRoutes from "./route/public-route/public-route";
import PrivateRoutes from "./route/private-route/private-route";
import {setLoginDetails} from "./action/set-action-details";
import ErrorBoundary from "./components/ErrorBoundary";

function App(props) {
    return (
        <ErrorBoundary name="App" showRetry={true}>
            <div className="App">
                <Router>
                    {props.loginData.length < 1 ? <PublicRoutes /> : <PrivateRoutes />}
                </Router>
                <ToastWrapper />
            </div>
        </ErrorBoundary>
    );
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);